const MetricDetailTypes = {
  FETCH_ALL_CLASS_BOX_PLOT_OBJECTS: 'FETCH_ALL_CLASS_BOX_PLOT_OBJECTS',
  FETCH_ANNUAL_FLOW_OBJECT: 'FETCH_ANNUAL_FLOW_OBJECT',
  UPDATE_LOADING_OBJECT: 'UPDATE_LOADING_OBJECT',
  TOGGLE_DRAWER_OBJECT: 'TOGGLE_DRAWER_OBJECT',
  TOGGLE_METRIC_OBJECT: 'TOGGLE_METRIC_OBJECT',
  TOGGLE_LOG_SCALE_OBJECT: 'TOGGLE_LOG_SCALE_OBJECT',
  TOGGLE_HYDROGRAPH_OVERLAY_OBJECT: 'TOGGLE_HYDROGRAPH_OVERLAY_OBJECT',
  FETCH_HYDROGRAPH_OVERLAY_OBJECT: 'FETCH_HYDROGRAPH_OVERLAY_OBJECT',
  TOGGLE_FIXED_YAXIS_OBJECT: 'TOGGLE_FIXED_YAXIS_OBJECT',
  GET_FIXED_YAXIS_VALUE_OBJECT: 'GET_FIXED_YAXIS_VALUE_OBJECT',
  GET_BOX_PLOT_FIXED_YAXIS_VALUE_OBJECT:
    'GET_BOX_PLOT_FIXED_YAXIS_VALUE_OBJECT',
};

export default MetricDetailTypes;



// WEBPACK FOOTER //
// ./src/action-types/metricDetail.js